import React from 'react';

import Analytics from '@wetransfer/transfer/modules/analytics';
import { Button } from '@wetransfer/transfer/spaces-bundle/components/Button/Button';

import './ProButton.scss';

export interface Props {
  text?: string;
  onClick(): void;
  isFreeUser?: boolean;
  label?: string;
  href?: string;
}

export function proTrackingClick({
  event,
  action = {
    snowplow: 'click_button_pro_header_cta',
    googleAnalytics: 'Pro Upgrade',
  },
  label,
}: {
  action?: {
    snowplow: string;
    googleAnalytics: string;
  };
  label: string;
  event: string;
}): void {
  Analytics.trackSnowplowEvent({
    category: 'pro',
    action: action.snowplow,
    label,
  });

  Analytics.trackGoogleEvent({
    category: 'pro-upgrade-button-click',
    action: action.googleAnalytics,
    label,
  });

  Analytics.trackWithPixelOrSDK(event);
}

export const ProButton: React.FC<Props> = ({ text, href, onClick }) => {
  return (
    <Button as="a" className="ProButton" href={href} onClick={onClick}>
      <span className="ProButton__text">{text}</span>
    </Button>
  );
};
